import { Link } from 'react-router-dom';

/**
 * In-shell "not found" view (PRO-0250, §4). An unknown client route resolves to
 * this (not an HTTP error); it offers a route back to Home rather than stranding
 * the user.
 */
export function NotFoundView() {
  return (
    <section aria-labelledby="not-found-heading">
      <h1 id="not-found-heading">Page not found</h1>
      <p>The page you were looking for isn&rsquo;t part of this workspace.</p>
      <Link to="/">Return to Home</Link>
    </section>
  );
}
